import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { EducatorDashboard } from "../EducatorDashboard/educatorDashboard";
import { StudentDashboard } from "../StudentDashboard/studentDashboard";
import { Loader } from "../Common/Loader/loader";
import { dashboardSx } from "./styles";

export const Dashboard = () => {
  const userData = useSelector((state) => state.userData.data);
  const is_educator = userData?.is_educator
  const loading = useSelector((state) => state.userData.loading);
  return (
    <>
      {
        loading || is_educator === undefined ?
          <Loader height={"100vh"}/> :
          <Box sx={dashboardSx.root}>
            {
              is_educator ?
                <EducatorDashboard />
                : 
                <StudentDashboard/>
            }
          </Box>
      }

    </>
  );
};
